import { render, staticRenderFns } from "./NextDays.vue?vue&type=template&id=89524274&scoped=true&"
import script from "./nextdays.js?vue&type=script&lang=js&"
export * from "./nextdays.js?vue&type=script&lang=js&"
import style0 from "./nextdays.scss?vue&type=style&index=0&id=89524274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89524274",
  null
  
)

export default component.exports